module.exports = __webpack_public_path__ + "static/media/cliente.e722d4af.png";